import { useEffect } from "react";
import { useSelector } from "react-redux";
import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
import { getSearchFetchStatus, getSearchResultsFlights } from "../../../store/searchResults/selectors.js";
const util = createTrackingUtils({
    name: "flights_web_2_step_ml_ranker",
    stages: {
        main: 1,
        meta: 2,
        direct: 3,
        desktop: 4,
        mobile: 5,
        genius: 6
    },
    goals: {},
    defaultStage: 1
});
export function useFlightsWeb2StepMlRanker() {
    const searchFetchStatus = useSelector(getSearchFetchStatus);
    const searchResultsFlights = useSelector(getSearchResultsFlights);
    const { isDirect, isMeta, isMobile, isDesktop, isGenius } = useProfiler();
    useEffect(() => {
        if (searchFetchStatus !== "success")
            return;
        if (!searchResultsFlights?.length)
            return;
        util.stages.main();
        if (isMeta())
            util.stages.meta();
        if (isDirect())
            util.stages.direct();
        if (isMobile())
            util.stages.mobile();
        if (isDesktop())
            util.stages.desktop();
        if (isGenius())
            util.stages.genius();
    }, [searchFetchStatus, searchResultsFlights, isDirect, isMeta, isMobile, isDesktop, isGenius]);
    return {};
}
